<template>
    <fade-transition>
        <nav v-show="menuOpened" class="navbar navbar-expand-lg">
            <div class="collapse navbar-collapse show" id="navbarSupportedContent">
                <div ref="navbarInner" :class="navbarInnerClasses">
                    <div ref="navbarInnerContainer" class="navbar__innerContainer">
                        <fade-transition :delay="100" @enter="enter">
                            <nav v-if="contentShow" class="menu">
                                <ul :class="menuClasses"
                                    @mouseenter="onMenuHover"
                                    @mouseleave="onMenuLeave"
                                >
                                    <li v-for="menu in menus"
                                        :key="menu.name"
                                        @mouseenter="onMenuItemHover(menu)"
                                        @mouseleave="onMenuItemLeave"
                                    >
                                        <router-link :to="menu.link"
                                                     :class="menuItemClasses(menu)"
                                                     @click.native="onMenuClick(menu.link)">{{menu.name}}
                                        </router-link>
                                    </li>
                                </ul>
                            </nav>
                        </fade-transition>

                        <fade-transition :delay="200">
                            <div v-if="contentShow" class="socialListContainer">
                                <div class="socialListTitle">
                                    Follow Us
                                </div>

                                <social-list></social-list>
                            </div>
                        </fade-transition>
                    </div>
                </div>
            </div>
        </nav>
    </fade-transition>
</template>

<script>
    import _throttle from 'lodash/throttle'
    import {mapState, mapActions} from 'vuex'
    import SlideYUpTransition from "vue2-transitions/src/Slide/SlideYUpTransition";
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";

    export default {
        data() {
            return {
                contentShow: false,
                menuHover: false,
                menuItemHover: null,
                pathname: null,
                trottledOnResize: null,
                navbarInnerH: 0,
                navbarInnerContainerH: 0,
            }
        },
        created() {

        },
        computed: {
            classes() {
                return [
                    'navbar-collapse show',
                ]
            },
            menuClasses() {
                return [
                    'menu',
                    {'menu-hovered': this.menuHover},
                ]
            },
            navbarInnerClasses() {
                return [
                    'navbar__inner',
                    {'navbar__inner-small': this.navbarInnerContainerH > this.navbarInnerH},
                ]
            },
            ...mapState({
                menuOpened: state => state.ui.menuOpened,
                menus: state => state.menus.list,
            }),

        },
        mounted() {
            this.navbarInnerContainer = $(this.$refs.navbarInnerContainer)
            this.navbarInner = $(this.$refs.navbarInner)

            this.trottledOnResize = _throttle(this.onResize, 30);
            window.addEventListener('resize', this.trottledOnResize)
            this.onResize()

            //console.log('menu panel: mounted')
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.trottledOnResize)
        },
        watch: {
            menuOpened() {
                setTimeout(() => {
                    this.contentShow = this.menuOpened
                }, 0)

                if (this.menuOpened) {
                    this.pathname = location.pathname
                }
            }
        },
        methods: {
            ...mapActions({
                closeMenu: 'ui/closeMenu',
            }),
            menuItemClasses(menu) {
                return [
                    {'link-hovered': this.menuItemHover === menu},
                ]
            },
            onMenuClick(link) {
                //debugger
                if (this.pathname.substr(0, link.length) === link) {
                    this.closeMenu()
                }
            },
            onMenuHover() {
                this.menuHover = true
            },
            onMenuLeave() {
                this.menuHover = false
            },
            onMenuItemHover(menu) {
                this.menuItemHover = menu
            },
            onMenuItemLeave() {
                this.menuItemHover = null
            },
            enter() {
                this.onResize()
            },
            onResize() {
                this.navbarInnerContainerH = this.navbarInnerContainer.height()
                this.navbarInnerH = this.navbarInner.height()
            },
        }
    }
</script>
